import React from 'react';

function Change() {
  return (
    <>
      <h2 className="font-bold text-center pb-3" id="change"> Обмін та повернення</h2>
      <div className="p-3">
        <p>
      Повернути або обміняти взуття можна протягом 14 днів після покупки. Головна умова, яка важлива для нас - відсутність
      помітних слідів носіння (перед тим, як обміняти або повернути, не можна носити взуття на вулиці, це відразу залишає
      сліди на підошві, навіть, якщо її помити)
      <br/><br/>
      По закону, має бути збережена коробка, але інколи з нею щось може трапитися на пошті і не завжди хочеться її зберігати,
      тому для нас ця умова бажана, але не обов’язкова.
      <br/><br/>
      Щоб здійснити обмін чи повернення, подзвоніть або напишіть в інстаграм ( <a className="color-blackk" href="https://www.instagram.com/dmk.style_man_/?hl=uk">@dmk.style_man_</a>) чи в будь-який з месенджерів.
      Менеджер вас проконсультує і оформить обмін або повернення.
      <br/><br/>
      <p className="font-size pb-1">Якщо коротко, процес обміну такий:</p> 
      <ul>
        <li>ви відправляєте нам посилку, яка вам не підійшла</li>
        <li>ми її отримуємо і на складі перевіряють стан</li>
        <li>якщо все добре, відправляємо вам інший розмір чи модель.</li>
      </ul>
      <p className="font-size pb-1">Повернення відбувається так:</p>      
        <ul>
        <li>ви також відправляєте нам посилку</li>
        <li>ми її отримуємо і перевіряємо</li>
        <li>і далі завдання переходить до бухгалтера, який протягом 3-7 днів зробить переказ коштів вам на карту</li>
      </ul>
    </p>
    </div>
</>
  );  
}

export default Change;